import { t } from '@ctcells/i18n'

/**
 * 비밀번호 정책 — 와이어프레임 `pwCheck()` 1025행 그대로.
 *
 * ⚠ 이 검사는 **입력 보조**다. 집행은 서버다.
 *   계약에 정책 조회 API 가 없어 와이어프레임 값을 상수로 뒀다. 서버가 정책을 내려주면
 *   그 값으로 갈아끼운다 — 화면 코드는 `passwordViolations()` 만 부르므로 여기 한 곳이다.
 */
export const PASSWORD_POLICY = {
  minLength: 12,
  /** 대문자 · 소문자 · 숫자 · 특수문자 중 몇 종을 섞어야 하는가 */
  minKinds: 3,
} as const

const KIND_PATTERNS = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/] as const

/**
 * 위반 목록. **빈 값이면 아무것도 내지 않는다** —
 * 입력 전에 규칙을 미리 보여주지 않는다(README §1-1).
 */
export function passwordViolations(value: string): string[] {
  if (value === '') return []

  const kinds = KIND_PATTERNS.filter((re) => re.test(value)).length
  const violations: string[] = []

  if (value.length < PASSWORD_POLICY.minLength) {
    violations.push(t('validation.password.minLength', { n: PASSWORD_POLICY.minLength }))
  }
  if (kinds < PASSWORD_POLICY.minKinds) {
    violations.push(t('validation.password.kinds', { n: PASSWORD_POLICY.minKinds }))
  }

  return violations
}

/**
 * 「새 비밀번호 확인」 칸 판정 — 내 계정의 변경 창과 관리자 재설정 창이 **같이** 쓴다.
 *
 * 🔴 확인 칸은 **화면 안에서만** 쓴다. 서버 본문(`PasswordResetEnvelope`)에는 그 칸이 없다 —
 *    같은지 본 뒤 새 비밀번호 하나만 보낸다.
 */
export const passwordConfirm = {
  /** 칸 아래에 「일치하지 않음」을 세울 때. 아직 안 친 확인 칸은 틀렸다고 하지 않는다 */
  mismatch: (next: string, confirm: string): boolean => confirm !== '' && confirm !== next,
  /** 보낼 수 있는가 — 둘 다 차 있고 같아야 한다 */
  matches: (next: string, confirm: string): boolean => next !== '' && next === confirm,
} as const
